"use strict";
/// <reference path="./typings/@cian/event-bus/index.d.ts" />
Object.defineProperty(exports, "__esModule", { value: true });
function getEventBusIfDefined() {
    if (window.ceb && typeof window.ceb === 'object' && typeof window.ceb.emit === 'function' && typeof window.ceb.subscribe === 'function') {
        return window.ceb;
    }
    return;
}
exports.getEventBusIfDefined = getEventBusIfDefined;
function getEventBusOrThrow() {
    if (!window.ceb) {
        throw new Error('Event bus not found in window.ceb');
    }
    if (typeof window.ceb !== 'object' || typeof window.ceb.emit !== 'function' || typeof window.ceb.subscribe !== 'function') {
        throw new Error('Invalid event bus found in window.ceb');
    }
    return window.ceb;
}
exports.getEventBusOrThrow = getEventBusOrThrow;
//# sourceMappingURL=index.js.map